import React from "react";
import styles from "./ContactSection.module.css";
import { Form } from "../Form/Form";
import { ContactInfo } from "../ContactInfo/ContactInfo";

function ContactSection() {
  return (
    <div id="contact_section" className={styles.container}>
      <h2 className={styles.title}>Estemos en contacto</h2>
      <Form
        position={{ gridColumn: "2/7" }}
        title="Dejame tu mensaje"
        messageLabel="Tu mensaje"
      ></Form>
      <ContactInfo></ContactInfo>
    </div>
  );
}

export { ContactSection };
